import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleSubmit,
    isLoading,
    validate
}) => {
    const { title, data } = formAttribute;    
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcname}
                            onChange={(event) => handleChange(event)}
                            name="vcname"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNIP">
                        <Form.Label>NIP</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vcnip} 
                            onChange={(event) => handleChange(event)} 
                            name="vcnip" 
                            placeholder="NIP"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            NIP tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNomorHp">
                        <Form.Label>Nomor Telepon / HP</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcphone}
                            onChange={(event) => handleChange(event)}
                            name="vcphone"
                            placeholder="Nomor Telepon / HP" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nomor Telepon / HP tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupUseAccount">
                        <Form.Check 
                            type="checkbox"
                            label="Menggunakan Akun?"
                            name="intfungsional"
                            checked={data?.intfungsional === 1 ? true : false}
                            onChange={(event) => handleChange(event)}
                        />
                    </Form.Group>
                    {
                        data?.intfungsional === 1 && (<>
                            <Form.Group className="mb-3" controlId="formGroupUserName">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={data?.vcusername}
                                    onChange={(event) => handleChange(event)}
                                    name="vcusername"
                                    placeholder="Username"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Username tidak boleh kosong.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={data?.vcpassword}
                                    onChange={(event) => handleChange(event)}
                                    name="vcpassword"
                                    placeholder="Password"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Password tidak boleh kosong.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </>)
                    }

                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;